/* New pre order login by rocket*/
$(document).ready(function() {
    //Product page trigger
    if ($(".product-form").length > 0) {
        if($(".product-form .preorder-message").length > 0) {
            if ($(".product-form .quantity-submit-row__submit .metafield-rich_text_field").length < 1) {
                var product_id = $(".product-form form").attr("data-product-id");
                var preorder_msg = $(".product-form .preorder-message").html();
                var preorder_msg_elem = $(".quantity-submit-row__submit");
                var preorder_line_elem = $(".product-form").find(".quantity-submit-row__submit");
                var atc_button_elem = $(".product-form").find("#product-add-to-cart");
                triggerPreOrder(atc_button_elem,preorder_line_elem,preorder_msg_elem,preorder_msg,product_id);
            }
        }
        if($(".product-form .lastchance-message").length > 0) {
            var lastchance_msg = $(".product-form .lastchance-message").html();
            var lastchance_line_elem = $(".product-form").find(".quantity-submit-row__submit");
            lastchance_line_elem.prepend(lastchance_msg);
        }
    }

    //Variants event
    $(document).on('change', '.opt-btn.js-option', function() {
        if(!$(this).hasClass("is-unavailable")){
            if($(this).closest(".product-form").find(".quantity-submit-row__submit .metafield-rich_text_field").length){

                var metafield_html = $(this).closest(".product-form").find(".quantity-submit-row__submit .metafield-rich_text_field").html();
                if (metafield_html.indexOf("Final Sale") < 0){
                    var atc_button =$(this).closest(".product-form").find("#product-add-to-cart");
                    addPreOrderLabel(atc_button);
                }
            }
        }
    });

    //Quickbuy observer
    
    $(document).on('click', '.quickbuy-toggle', function(event) {
        waitForElm('.quickbuy-container .product-form').then((elm) => {
            var selected = elm.querySelector(".buy-buttons-row");
            var form_element = $(selected).find("form");
            var product_id = form_element.attr("data-product-id");

            if($("#preorder-message-"+product_id).length){
                var atc_button_elem = form_element.find("#product-add-to-cart");
                var preorder_msg = $("#preorder-message-"+product_id).html();
                var preorder_msg_elem = form_element.find(".quantity-submit-row__submit");
                var preorder_line_elem = form_element.find(".quantity-submit-row__submit");

                triggerPreOrder(atc_button_elem,preorder_line_elem,preorder_msg_elem,preorder_msg,product_id); 
            }
            if($("#lastchance-message-"+product_id).length){
                var add_to_cart_parent = form_element.find(".quantity-submit-row__submit");
                var lastchance_elem = $("#lastchance-message-"+product_id).css("display", "block").clone();
                $("#lastchance-message-"+product_id).remove();
                add_to_cart_parent.prepend(lastchance_elem);
            }

            // if(window.mm_geo){
            //     trigger_localization(mm_geo);
            // }
        });

    });

    $(document).on('click', '#product-add-to-cart', function() {
        setTimeout(() => {
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                cache: false,
                dataType: 'json',
                success: function(cart) {
                    getCartData(cart);
                }
            });
        }, 1500);
    });

    $(document).on('click', '#updates_dec_1, #updates_inc_1', function() {
        setTimeout(() => {
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                cache: false,
                dataType: 'json',
                success: function(cart) {
                    $("#preordermessage").parent().parent().addClass("hidemessage");
                    $("#noreturnablemessage").parent().parent().addClass("hidemessage");
                    getCartData(cart);
                }
            });
        }, 1500);
    });
    

});
    
function triggerPreOrder(atc_button,preorder_line_elem,preorder_msg_elem,preorder_msg,product_id){
    //Update add to cart label to PRE ORDER
    setTimeout(function() {
        atc_button.attr("value", "PRE ORDER");
        atc_button.html("PRE ORDER");
    }, 250);
    //Add thePRE ORDER message abothe the button
    preorder_msg_elem.find('.metafield-rich_text_field').remove(); 
    preorder_msg_elem.prepend(preorder_msg);

    //Add the PRE ORDER line to the order
    var line_preorderproduct = '<input id=preorder-line-'+product_id+'" class="item-contains-preorder" type="hidden" name="properties[Pre Order Item]" value="Active">';
    preorder_line_elem.find('.item-contains-preorder').remove(); 
    preorder_line_elem.prepend(line_preorderproduct);

}

//Uodate the add to cart button label and value
function addPreOrderLabel(atc_button){
    setTimeout(function() {
        atc_button.attr("value", "PRE ORDER");
        atc_button.html("PRE ORDER");
    }, 1);
}

//Observer
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

//Get products from the cart
function getCartData(cart){
    if(cart.item_count > 0){
        cart_products = cart.items;
        $.each(cart_products, function( key, item ) {
            let product_handle = item.handle;
            let product_id = item.handle;
            fetchProduct(product_handle, product_id);
        });
    }
}

//Get product info
function fetchProduct(handle,product_id){
    jQuery.getJSON(window.Shopify.routes.root + 'products/'+handle+'.js', function(product) {

        //Pre order item in the cart
        if (product.title.indexOf("PRE-ORDER") >= 0 || product.title.indexOf("PRE ORDER") >= 0){
            getNotificationToCart("pre-order");
        }

        //No return product in the cart
        $.each(product.tags, function( key, tag ) {
            if(product.title.indexOf("Route") < 0 && tag == "no-return"){
                getNotificationToCart("no-return");
            }
        });
        
    });
}

//Show or Hide cart notifications
function getNotificationToCart(type){
    if(type == 'pre-order'){
        $("#preordermessage").parent().parent().removeClass("hidemessage");
    }
    if(type == 'no-return'){
        $("#noreturnablemessage").parent().parent().removeClass("hidemessage");
    }
}